<template>
  <TableRowHover :to="routerLink" v-on="$listeners">
    <TableCell :class="$style.cell">
      {{ year }}
    </TableCell>
    <TableCell :class="$style.cell">
      {{ renderDatetime(lastModified, locale) }}
    </TableCell>
    <TableCell :class="$style.cell">
      <ReportStatusInline :status="status" />
    </TableCell>
    <template #icon>
      <IconView :class="$style.icon" />
    </template>
  </TableRowHover>
</template>

<script>
import { mapGetters } from 'vuex'
import { renderValue, renderDatetime } from '@/helpers/render'
import { REPORT_STATUSES } from '@/store/report/report-settings'
import TableRowHover from '@/components/TableRowHover.vue'
import TableCell from '@/components/TableCell.vue'
import IconView from '@/components/_icons/IconView.svg'
import ReportStatusInline from '@/components/Account/Reports/ReportStatusInline.vue'

export default {
  name: 'ReportsTableRow',

  components: {
    TableRowHover,
    TableCell,
    IconView,
    ReportStatusInline,
  },

  props: {
    year: {
      type: Number,
      required: true,
    },
    lastModified: {
      type: Date,
    },
    status: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(REPORT_STATUSES).includes(value)
      },
    },
    routerLink: {
      type: [Object, String],
    },
  },

  data() {
    return {
      renderValue,
      renderDatetime,
    }
  },

  computed: {
    ...mapGetters({
      locale: 'page/locale',
    }),
  },
}
</script>

<style lang="scss" module>
.cell {
  vertical-align: middle;
  white-space: nowrap;
  height: 56px;
}

.icon {
  transform: translateY(8px);
}
</style>
